import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Order, ProcessType, Product} from "../../../../../store/state/order.state";
import {deviceType} from "../../../../../app.component";
import {FormGroup} from "@angular/forms";
import {Observable} from "rxjs";
import {BaseSubFormComponent} from "../../../../../umbrella-common/components/base-sub-form.component";
import {AuditDatesFormService} from "../audit-dates-form.service";

@Component({
    selector: 'initial-certification-dates',
    templateUrl: './initial-certification-dates.template.html',
    styleUrls: ['./initial-certification-dates.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InitialCertificationDatesComponent extends BaseSubFormComponent implements OnInit, OnDestroy {

	readonly DEVICE_TYPE = deviceType;

	@Input() order: Order;
	@Input() product: Product;
	@Input() clientLogged: boolean;

	form: FormGroup;

	constructor(private formService: AuditDatesFormService) {
		super(formService);
	}

	ngOnInit(): void {
		this.form = this.formService.buildSubForm(this.product.standard.name, this.totalSubForms(this.order), ProcessType.INITIAL_CERTIFICATION, this.product);
	}

	override ngOnDestroy(): void {
		this.formService.destroySubForm(this.product.standard.name);
	}

	updateDateFormControlAndValidateAllDates(dateFormControlName: string, value: any) {
		this.formService.updateFormControl(dateFormControlName, value, this.product.standard.name);
		this.formService.triggerSubFormValidations(this.product.standard.name);
	}

	get desiredStage1AuditDate(): Date {
		return this.product.additionalQuestions.initialCertificationQuestions.desiredStage1AuditDate;
	}

	get desiredStage2AuditDate(): Date {
		return this.product.additionalQuestions.desiredNextAuditDate;
	}

	getErrorsIfInvalid(formControlName): Observable<string> {
		return this.formService.getErrorsIfInvalid(this.product.standard.name, formControlName);
	}

	override isInvalid(formControlName: string) {
		if (this.formService.getFormControl(this.product.standard.name, formControlName)) {
			return this.formService.isInvalid(this.product.standard.name, formControlName);
		}
		return true;
	}

	getFormKey(): string {
		return this.product.standard.name;
	}

	protected iso27701HasItsOwnSubForm(): boolean {
		return true;
	}

	override totalSubForms(order: Order): number {
		return order.products.length;
	}
}
